/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Legal_Gate_EyebrowInputs */

const en_legal_gate_eyebrow = /** @type {(inputs: Legal_Gate_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Before you continue`)
};

const pl_legal_gate_eyebrow = /** @type {(inputs: Legal_Gate_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zanim przejdziesz dalej`)
};

/**
* | output |
* | --- |
* | "Before you continue" |
*
* @param {Legal_Gate_EyebrowInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const legal_gate_eyebrow = /** @type {((inputs?: Legal_Gate_EyebrowInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Legal_Gate_EyebrowInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_legal_gate_eyebrow(inputs)
	return en_legal_gate_eyebrow(inputs)
});